export default function hasWidgetParams(
  params?: Record<string, unknown> | null
): boolean {
  const paramsValues = params ? Object.values(params) : []

  return !paramsValues.every((value) => value === null || value === undefined)
}
